<template>
	<button class="spreadsheet-toggle" @click="open" data-cy="spreadsheet-toggle" title="Open the current selection as an editable spreadsheet">
		<mdi table />
		<span>Sheet</span>
	</button>
</template>

<script>
// Opens the current entry list selection in the spreadsheet view. Only the spaces
// and environments that have the bulk-editing workflow get the button.
export const extension = {
	type: 'contentList',
	location: 'toolbar',
	// ATT: this is an OR *across* fields - that one space in any environment, or
	//      those environments in any space. The declarative filters AND across
	//      fields, so they cannot express it; this is what when() is for.
	//      Written as `spaceIds` + `environments` it would mean "that space AND
	//      those environments", which is not what the hardwired condition did.
	when: ctx => ctx.spaceId === 'dwdvglhvffjs'
		|| ctx.environment === 'world'
		|| ctx.environment === 'world-test',
}

export default {
	name: 'SpreadsheetToggle',
	props: { ctx: Object },
	methods: {
		// carry the current filter (already serialized into the route query by the
		// list view) over to the spreadsheet, dropping the split-view-only params
		open() {
			const query = { ...this.$route.query }
			delete query.split
			delete query.entry
			delete query.stack
			this.$router.push({ path: this.ctx.base + '/entries/spreadsheet', query })
		},
	},
}
</script>
